import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface IContentPart{
  table: any;
  width?: any;
  setHeight?: (h: number) => void;
}

export const ContentPart = (props: IContentPart) => {
  const { t } = useTranslation();
  let blockHeight: number = window.innerHeight - 290;
  const ref = useRef(null);
  useEffect(() => {
    if(ref.current !== null && props.setHeight !== undefined){
      let element = ref.current as HTMLElement;
      props.setHeight(element.clientHeight - 50); 
    }
  }, [ref])
  
  return (
    <div ref={ref} style={{height: `${blockHeight}px`, width:`${props.width}px`}} id='contentPart'>
      <div className="content">
      
        <div className="sideTable" style={{width: '100%', height: '100%'}}>
          <div className="tableBlock">
            {React.cloneElement(props.table, {className: "table"})}
          </div>
        </div>
      </div>
    </div>
  )
}